import { useCallback } from 'react';
import { useAsyncValue } from '../../../../../../../../hooks';
import { remove } from '../../../../../../../../redux/api';
import { errorMessagesListFromResponse, type FailedFetchResponse } from '../../../../../../../../helpers/errors';
import useGetReleaseGroupIds from './useGetReleaseGroupIds';

const useUnpublishReport = () => {
  const { projectGroupId, releaseId } = useGetReleaseGroupIds();
  const {
    setPending,
    setResolve,
    setReject,
    isLoading,
    errors,
    value: isUnpublished,
  } = useAsyncValue<boolean>(false);
  const unpublishReport = useCallback(async () => {
    try {
      setPending();
      await remove(`/api/project_group/${projectGroupId}/release/${releaseId}/published-report`);
      setResolve(true);
    } catch (error) {
      setReject(errorMessagesListFromResponse(error as FailedFetchResponse).map((e) => e.toString()));
    }
  }, [projectGroupId, releaseId, setPending, setReject, setResolve]);

  return {
    unpublishReport,
    isLoading,
    errors: errors || [],
    isUnpublished: !!isUnpublished,
  };
};

export default useUnpublishReport;
